// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetRecoPythiaKombiModulRenderAppBestandteileData, GetRecoPythiaKombiModulRenderAppBestandteileErrors, GetRecoPythiaKombiModulRenderAppBestandteileResponses, GetRecoPythiaKombiModulRenderBestandteileData, GetRecoPythiaKombiModulRenderBestandteileErrors, GetRecoPythiaKombiModulRenderBestandteileResponses, GetRecoPythiaKombiModulRenderOutfitsData, GetRecoPythiaKombiModulRenderOutfitsErrors, GetRecoPythiaKombiModulRenderOutfitsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getRecoPythiaKombiModulRenderOutfits = <ThrowOnError extends boolean = false>(options: Options<GetRecoPythiaKombiModulRenderOutfitsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetRecoPythiaKombiModulRenderOutfitsResponses, GetRecoPythiaKombiModulRenderOutfitsErrors, ThrowOnError>({
        url: '/reco/pythia/kombi-modul/render/outfits',
        ...options
    });
};

export const getRecoPythiaKombiModulRenderBestandteile = <ThrowOnError extends boolean = false>(options: Options<GetRecoPythiaKombiModulRenderBestandteileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetRecoPythiaKombiModulRenderBestandteileResponses, GetRecoPythiaKombiModulRenderBestandteileErrors, ThrowOnError>({
        url: '/reco/pythia/kombi-modul/render/bestandteile',
        ...options
    });
};

export const getRecoPythiaKombiModulRenderAppBestandteile = <ThrowOnError extends boolean = false>(options: Options<GetRecoPythiaKombiModulRenderAppBestandteileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetRecoPythiaKombiModulRenderAppBestandteileResponses, GetRecoPythiaKombiModulRenderAppBestandteileErrors, ThrowOnError>({
        url: '/reco/pythia/kombi-modul/render/app/bestandteile',
        ...options
    });
};
